import { gql } from '@apollo/client';

import { BRAND_FRAGMENT } from '../fragments';

export const GET_AD_ACCOUNTS_BY_USER = gql`
  query adAccountsByUser($userId: ID!) {
    adAccountsByUser(userId: $userId) {
      edges {
        cursor
        node {
          id
          name
          brand {
            ...brandFragment
          }
          organizationId
          isBaymaxEnabled
        }
      }
      total
    }
  }
  ${BRAND_FRAGMENT}
`;
